import Vue from "vue";
import vuetwemoji from "vue-twemoji";

Vue.use(vuetwemoji, {
  baseUrl: "https://cdn.plan-your-van.com/twemoji/",
});
